import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import { fetchEventDetails } from "DashboardUserAction";
import { analyticsUpdateDateProps } from "AnalyticscommonActions";
import { DATE_FORMAT } from "Constants";
import AnalyticsMenu from "./analytics-menu";
import AnalyticsDashboard from "AnalyticsDashboard";
import GoogleAnalyticSetting from "GoogleAnalyticSetting";
import AnalyticsSession from "AnalyticsSession"; // Analytics Sessions
import AnalyticsSpeaker from "AnalyticsSpeaker"; // Analytics Speakers
import AnalyticsAttendeesNetwork from "AnalyticsAttendeesNetwork"; // Analytics Attendees Network
import AnalyticsAttendeesMessaging from "AnalyticsAttendeesMessaging"; // Analytics Attendees Messaging
import AnalyticsSocialfeed from "AnalyticsSocialfeed"; // Analytics Social Feeds
import AnalyticsSponsorsInsight from "AnalyticsSponsorsInsight"; // Analytics Sponsors Insight
import AnalyticsExhibitorsInsight from "AnalyticsExhibitorsInsight"; // Exhibitors Insight
import AnalyticsAdvertisementinsight from "AnalyticsAdvertisementinsight"; // Advertisementinsight Insight

class Analytics extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchEventDetails(this.props.session);
    this.props.analyticsUpdateDateProps(this.getInitialDate());
  }

  getInitialDate() {
    return {
      from: moment().subtract(6, "d").format(DATE_FORMAT),
      to: moment().format(DATE_FORMAT),
      enteredTo: null,
    };
  }

  renderAnalyticsOptionList() {
    let { analyticsMenus, selectedFeatures } = this.props;
    // console.log('selectedFeatures',selectedFeatures);
    // console.log('analyticsMenus',analyticsMenus);

    if (selectedFeatures && selectedFeatures.length > 0) {
      let socialisenable = _.filter(selectedFeatures, ["bsClass", "social"]);
      socialisenable = socialisenable[0]?.isenabled;

      let scheduleisenable = _.filter(selectedFeatures, [
        "bsClass",
        "schedule",
      ]);
      scheduleisenable = scheduleisenable[0]?.isenabled;

      let attendeeisenable = _.filter(selectedFeatures, [
        "bsClass",
        "attendee",
      ]);
      attendeeisenable = attendeeisenable[0]?.isenabled;

      let messageisenable = _.filter(selectedFeatures, ["bsClass", "message"]);
      messageisenable = messageisenable[0]?.isenabled;

      let sponsorisenable = _.filter(selectedFeatures, ["bsClass", "sponsor"]);
      sponsorisenable = sponsorisenable[0]?.isenabled;

      let exhibitorisenable = _.filter(selectedFeatures, [
        "bsClass",
        "exhibitor",
      ]);
      exhibitorisenable = exhibitorisenable[0]?.isenabled;

      let speakerisenable = _.filter(selectedFeatures, ["bsClass", "speaker"]);
      speakerisenable = speakerisenable[0]?.isenabled;

      return analyticsMenus.map((item, index) => {
        if (item.iconName == "sponsorsinsight") {
          item.isenabled = sponsorisenable;
        }
        if (item.iconName == "socialfeed") {
          item.isenabled = socialisenable;
        }
        if (item.iconName == "exhibitorsinsight") {
          item.isenabled = exhibitorisenable;
        }
        if (item.iconName == "speaker") {
          item.isenabled = speakerisenable;
        }
        if (item.iconName == "session") {
          item.isenabled = scheduleisenable;
        }
        if (item.iconName == "attendeesnetwork") {
          item.isenabled = attendeeisenable;
        }
        if (item.iconName == "attendeesmessaging") {
          item.isenabled = messageisenable;
        }

        if (item && item.isenabled == true) {
          return <AnalyticsMenu key={item.iconName} item={item} />;
        }
      });
    }
  }

  render() {
    return (
      <div>
        <div className="content-parent-container">
          <div className="content-submenu vertical-line">
            <div>
              <ul className="list-group">{this.renderAnalyticsOptionList()}</ul>
            </div>
          </div>
          <div
            className="content-subcontainer"
            // style={{ width: `${contentContainerWidth}px` }}
          >
            <Route
              path="/dashboard/analytics/dashboard"
              component={AnalyticsDashboard}
            />
            <Route
              path="/dashboard/analytics/googleanalytic"
              component={GoogleAnalyticSetting}
            />
            <Route
              path="/dashboard/analytics/session"
              component={AnalyticsSession}
            />
            <Route
              path="/dashboard/analytics/speaker"
              component={AnalyticsSpeaker}
            />
            <Route
              path="/dashboard/analytics/attendeesnetwork"
              component={AnalyticsAttendeesNetwork}
            />
            <Route
              path="/dashboard/analytics/attendeesmessaging"
              component={AnalyticsAttendeesMessaging}
            />
            <Route
              path="/dashboard/analytics/socialfeed"
              component={AnalyticsSocialfeed}
            />
            <Route
              path="/dashboard/analytics/sponsorsinsight"
              component={AnalyticsSponsorsInsight}
            />
            <Route
              path="/dashboard/analytics/exhibitorsinsight"
              component={AnalyticsExhibitorsInsight}
            />
            <Route
              path="/dashboard/analytics/advertisementinsight"
              component={AnalyticsAdvertisementinsight}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    analyticsMenus: state.analyticsMenus,
    selectedFeatures: state.selectedFeatures,
  };
}

export default connect(mapStateToProps, {
  fetchEventDetails,
  analyticsUpdateDateProps,
})(Analytics);
